import * as z from 'zod';

export const Contact = z.object({});
